<template>
    <div id="visitor-history" class="container-fluid">
        <b-row id="visitor-history-row">
            <div style="margin-left: 18px; margin-right: 5px">
                <b-form-group
                    style="width: 95px"
                    id="start-date-input-group"
                    :label="$t('message.first')"
                    class="mb-1 custom-input"
                    label-for="start-date-input"
                    label-sr-only
                >
                    <datetime
                        v-model="startDate"
                        :max-datetime="maxDate"
                        :min-datetime="lastFiveYear"
                        :phrases="phrases"
                        :placeholder="$t('message.startDate')"
                        auto
                        input-class="form-control rounded-0"
                        input-id="start-date-input"
                        type="datetime"
                        @input="saveDate"
                    />
                </b-form-group>
            </div>
            <b-col style="display: flex; gap: 10px">
                <b-form-group
                    style="width: 95px"
                    id="end-date-input-group"
                    :label="$t('message.last')"
                    class="mb-1 custom-input"
                    label-for="end-date-input"
                    label-sr-only
                >
                    <datetime
                        v-model="endDate"
                        :max-datetime="maxDate"
                        :min-datetime="lastFiveYear"
                        :phrases="phrases"
                        :placeholder="$t('message.endDate')"
                        auto
                        input-class="form-control rounded-0"
                        input-id="end-date-input"
                        type="datetime"
                        @input="saveFilters"
                    />
                </b-form-group>
                <a-select
                    id="channel-filter"
                    v-model="selectedChannel"
                    mode="multiple"
                    :default-value="selectedChannel"
                    style="width: 180px"
                    :placeholder="$t('message.allChannels')"
                    @change="filterByChannel"
                >
                    <a-select-option v-for="channel in channel" :key="channel._id" :value="channel._id">
                        {{ channel.name }}
                    </a-select-option>
                </a-select>
            </b-col>
            <b-col cols="2">
                <b-form-group
                    id="query-input-group"
                    :label="$t('message.query')"
                    class="mb-1 custom-input"
                    label-for="query-input"
                    label-sr-only
                >
                    <b-form-input
                        id="query-input"
                        v-model="query"
                        :placeholder="$t('message.query')"
                        class="rounded-0"
                        name="query"
                        @change="saveFilters"
                    />
                </b-form-group>
            </b-col>
            <b-col class="custom-input">
                <a-rate v-model="point" :allow-clear="true" @change="saveFilters" />
            </b-col>
            <b-col cols="2">
                <b-form-group class="mb-1 custom-input">
                    <b-form-select v-model="selectedUser" class="mb-3" @change="saveFilters">
                        <option :value="null">
                            {{ $t("message.allUsers") }}
                        </option>
                        <option value="only-chatbot">{{ $t("message.chatBot") }}</option>
                        <option v-for="item in usersFilter.data" :key="item._id" :value="item._id">
                            {{ item.name }}
                        </option>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="2">
                <b-form-group id="query-input-group3" class="mb-1 custom-input">
                    <b-form-select v-model="selectedCustomerDomains" class="mb-3" @change="saveFilters">
                        <option :value="null">
                            {{ $t("message.allSites") }}
                        </option>
                        <option v-for="site in customerDomains" :key="site" :value="site">
                            {{ site }}
                        </option>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <supsis-table
            :columns="columns"
            :rows="visitors.data"
            :bottom-pagination="true"
            :pagination-cursor="paginationCursor"
            :options="tableOptions"
            :bottomAlign="'space-between'"
            :headAlign="'right'"
            :downloadOptions="{
                downloadAll: true,
                downloadTable: true,
            }"
            :tableSettings="true"
            @cursor-changed="(cursor) => (paginationCursor = cursor)"
            @download-table="exportToExcel"
            @download-all="downloadAsFile"
            @table-settings="openVisitorHistorySettingsModal"
        />
        <Modal2
            id="visitor-history-modal"
            v-if="visible"
            @cancel="visible = false"
            :visible="visible"
            :title="$t('message.visitorHistory')"
            :description="$t('message.visitorHistoryDescription')"
            :show-footer="false"
            :maskClosable="false"
            :width="1000"
        >
            <div v-if="filteredMessages.length" class="filteredMessages">
                <div class="filteredMessages">
                    <div class="parent-div">
                        <div>
                            <div class="display-flex">
                                <span
                                    class="icon material-icons"
                                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                                    :content="$t('coupon.name')"
                                    >person</span
                                >
                                {{ selectedHistory.visitor.fullname || "-" }}
                            </div>
                        </div>
                        <div>
                            <div class="display-flex">
                                <span
                                    class="icon material-icons"
                                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                                    :content="$t('coupon.email')"
                                    >mail</span
                                >
                                {{ selectedHistory.visitor.email || "-" }}
                            </div>
                        </div>
                        <div>
                            <div class="display-flex">
                                <span
                                    class="icon material-icons"
                                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                                    :content="$t('coupon.phone')"
                                    >phone</span
                                >
                                {{ getPhoneNumber() }}
                            </div>
                        </div>
                        <div v-if="!visitor.isBlocked" @click="ban()">
                            <div class="display-flex">
                                <span
                                    class="icon material-icons"
                                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                                    :content="$t('message.block_')"
                                    >block</span
                                >
                                {{ $t("message.block_") }}
                            </div>
                        </div>
                        <div v-else @click="unban()">
                            <div class="display-flex">
                                <span
                                    class="icon material-icons"
                                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                                    :content="$t('message.block_')"
                                    >block</span
                                >
                                {{ $t("message.block_") }} Kaldır
                            </div>
                        </div>
                        <div class="display-flex">
                            <vue-excel-xlsx
                                :columns="downloadConversationFields()"
                                :data="downloadConversationData()"
                                :fileName="downloadConversationName"
                                :sheetName="'Page 1'"
                                class="download-button"
                                style="justify-self: end; width: 36px; align-self: center"
                            >
                                <md-icon class="material-icons">download</md-icon>
                            </vue-excel-xlsx>
                            {{ $t("message.download") }}
                        </div>
                    </div>
                </div>
                <div v-if="filteredMessages.length" v-chat-scroll class="messages">
                    <MessageList
                        :always-scroll-to-bottom="false"
                        :colors="colors"
                        :messages="getMessages()"
                        :participants="getParticipants()"
                        :contextMenuVisable="false"
                    />
                </div>
                <div class="back-and-forth-button">
                    <a-button @click="navigateHistory(-1)"> <</a-button>
                    <a-button @click="navigateHistory(1)"> ></a-button>
                </div>
            </div>
            <div v-else>
                <b-alert show variant="info">{{ $t("message.chatNotFound") }}</b-alert>
            </div>
        </Modal2>
        <Modal2
            v-if="visitorHistorySettingsModalVisible"
            id="tableColumns"
            :title="$t('message.tableSettings')"
            @cancel="closeVisitorHistorySettingsModal"
            :show-footer="false"
        >
            <div>Tabloda Görmek İstediğiniz Sütunları Seçiniz</div>
            <div class="tableSettings">
                <div v-for="(col, i) in defaultCols" :key="col.key" v-if="col.key !== 'actions'">
                    <div class="item">
                        <div class="checkbox-group">
                            <b-form-checkbox
                                v-model="tableCols[col.key]"
                                :disabled="
                                    Object.values(tableCols).filter((x) => x === true).length > 12 &&
                                    !tableCols[col.key] &&
                                    customLoginFormEnabled
                                "
                                @input="toLocalStorage"
                            >
                                {{ col.title }}
                            </b-form-checkbox>
                        </div>
                    </div>
                    <!-- Eğer i çift sayıdaysa bir sonraki çifti başlat -->
                    <div v-if="i % 2 === 1" class="clear"></div>
                </div>
            </div>
        </Modal2>
    </div>
</template>

<script>
import moment from "moment";
import { Settings } from "luxon";
import { mapActions, mapGetters, mapState } from "vuex";
import * as _ from "lodash";
import MessageList from "./popup-chat/MessageList";
import { log2 } from "../utils/log2";
import { toNewMessagesModel } from "../utils/chat";
import PassedTimeCounterTimeFormat from "./PassedTimeCounterTimeFormat";
import { expertToExcel } from "../utils/utils";
import Pagination from "./Pagination";
import SearchIcon from "./svg/SearchIcon";
import { i18n } from "../language";
import { getOrUpdateFilters } from "../utils/persistenceStorage";
import EyesIcon from "./svg/EyesIcon.vue";
import Modal2 from "./common/Modal2.vue";
import IconButton from "../views/Pages/Settings/components/IconButton.vue";
import SYSTEM_PUBSUB from "../utils/systemPubSub";
import { sendSocketMessage, socketMessageStream } from "../utils/socketStream";
import { filter, first, timeout } from "rxjs/operators";
import TimeUtils from "../utils/TimeUtils";
import SupsisTable from "./SupsisTable.vue";

Settings.defaultLocale = i18n.locale;
const log = log2("VisitorHistory");

const defaultStartDate = moment().startOf("day").toISOString();
const defaultEndDate = moment().endOf("day").toISOString();

const filters = getOrUpdateFilters("chat-visitor-history");
export default {
    name: "VisitorHistory",
    props: ["timeSelect"],
    components: {
        SupsisTable,
        IconButton,
        Pagination,
        MessageList,
        PassedTimeCounterTimeFormat,
        SearchIcon,
        EyesIcon,
        Modal2,
    },
    data() {
        return {
            selectedChannel: filters.selectedChannel || [],
            tableCols: null,
            defaultCols: [],
            visitor: {},
            visible: false,
            selectedCustomerDomains: filters.selectedCustomerDomains || null,
            renderCount: 0,
            point: filters.point,
            currentSort: {
                columnKey: "createdDate",
                order: "ascend",
            },
            rowIndex: 0,
            pageSizes: ["10", "25", "50", "100"],
            usersFilter: [],
            selectedUser: filters.selectedUser || null,
            selectedHistory: {
                visitor: {},
                messages: [],
            },
            loading: true,
            startDate: moment(filters.startDate).toISOString(),
            endDate: moment(filters.endDate).toISOString(),
            query: filters.query,
            maxDate: moment().toISOString(),
            lastFiveYear: moment().subtract(5, "year").toISOString(),
            pageSize: !isNaN(filters.pageSize) ? filters.pageSize : 10,
            current: !isNaN(filters.current) ? filters.current : 1,
            phrases: {
                ok: this.$t("message.ok"),
                cancel: this.$t("message.cancel"),
            },
            colors: {
                header: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                launcher: {
                    bg: "#4e8cff",
                },
                messageList: {
                    bg: "#ffffff",
                },
                sentMessage: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                receivedMessage: {
                    bg: "#eaeaea",
                    text: "#222222",
                },
                userInput: {
                    bg: "#f4f7f9",
                    text: "#565867",
                },
            },
            visitorHistorySettingsModalVisible: false,
            paginationCursor: {
                total: 0,
                page: 1,
                perPage: 10,
            },
            tableOptions: {
                rowStyleOption: {
                    stripe: true,
                },
            },
        };
    },
    computed: {
        ...mapState({
            channel: (state) => state.channel.channels,
            visitors: (state) => state.visitor.visitors,
            users: (state) => state.user.users.data,
            customLoginInputs: (state) => state.customLoginForm.inputs,
            subjects: (state) => state.subject.subjects.data,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            customerDomains: (state) => state.visitor.customerDomains,
            selectedSubject: (state) => state.subject.selectedSubject,
            channels: (state) => state.channel.channels,
            customLoginFormEnabled: (state) => {
                const enabledFlag = state.setting.settings.customLoginFormEnabled;
                const isValid = !!state.customLoginForm.inputs.filter((x) => x.visible).length;
                return enabledFlag && isValid;
            },
        }),
        ...mapGetters({
            getUser: "user/getUser",
            isCustomLoginFormEnabled: "customLoginForm/isCustomLoginFormEnabled",
            isDarkMode: "user/isDarkMode",
            myActiveConversations: "chat/getMyActiveConversations",
        }),
        filteredMessages() {
            log(
                "filteredMessages",
                this.selectedHistory.messages,
                this.selectedHistory.messages.filter((m) => "undefined" === typeof m.type)
            );
            return this.selectedHistory.messages.filter((m) => "undefined" === typeof m.type);
        },
        downloadConversationName() {
            return `${this.selectedHistory.visitor.fullname}-${moment(this.selectedHistory.visitor.createdDate).format(
                "DD MMM, HH-mm-ss"
            )}`;
        },
        inputs() {
            return this.customLoginInputs.reduce((acc, cur) => {
                acc[cur._id] = cur;
                return acc;
            }, {});
        },
        columns() {
            let cols = [
                {
                    title: this.$t("message.whatsappNumber"),
                    field: "whatsappNumber",
                    key: "whatsappNumber",
                    renderBodyCell: ({ row }) => {
                        return <div>{row.whatsappNumber || "N/A"}</div>;
                    },
                },
                {
                    title: this.$t("whatsappChannel.channelName"),
                    field: "visitor.channel",
                    key: "visitor.channel",
                    renderBodyCell: ({ row }) => {
                        return this.channelMap[row.channel] || "N/A";
                    },
                },
                {
                    title: "Departman",
                    field: "subject",
                    key: "subject",
                    scopedSlots: { customRender: "subject" },
                    renderBodyCell: ({ row }) => {
                        return this.getSubject(row.subject);
                    },
                },
                {
                    title: this.$t("message.relatedAdvertisement"),
                    field: "metaReferrals",
                    key: "metaReferrals",
                    renderBodyCell: ({ row }) => {
                        return row.visitor.metaReferrals && row.visitor.metaReferrals.length > 0
                            ? row.visitor.metaReferrals[0].headline
                            : "N/A";
                    },
                },
                {
                    title: this.$t("akinon.country"),
                    field: "country",
                    key: "geoLocation.country",
                    renderBodyCell: ({ row }) => {
                        return row.geoLocation ? row.geoLocation.country : "N/A";
                    },
                },
                {
                    title: this.$t("message.start"),
                    field: "createdDate",
                    key: "createdDate",
                    renderBodyCell: ({ row }) => {
                        return moment(row.createdDate).format("D MMMM, HH:mm");
                    },
                },
                {
                    title: this.$t("message.finish"),
                    field: "destroyedDate",
                    key: "destroyedDate",
                    renderBodyCell: ({ row }) => {
                        return moment(row.destroyedDate).format("D MMMM, HH:mm");
                    },
                },
                {
                    title: this.$t("message.timeSpent"),
                    field: "timeSpent",
                    key: "timeSpent",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div style="line-height: 0px;">
                                <PassedTimeCounterTimeFormat date={row.connectedDate} endDate={row.destroyedDate} />
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("message.representative_"),
                    field: "user",
                    key: "user",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div
                                v-tippy={{
                                    followCursor: true,
                                    placement: "bottom-end",
                                    theme: this.isDarkMode ? "light-border" : "google",
                                }}
                                content={this.getUserNames(row)}
                            >
                                {this.getUserNames(row).length > 15
                                    ? this.getUserNames(row).slice(0, 11) + "..."
                                    : this.getUserNames(row)}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("message.star"),
                    field: "star",
                    key: "star",
                    renderBodyCell: ({ row }) => {
                        return row.point || "-";
                    },
                },
                {
                    title: this.$t("message.transactions"),
                    key: "_id",
                    field: "_id",
                    align: "right",
                    renderBodyCell: ({ row }) => {
                        const renderStartWABusiness = () => {
                            return (
                                this.isWABusiness(row) && (
                                    <a-button
                                        class="actionButton d-flex align-items-center classic-button"
                                        size="small"
                                        on-click={() => this.startWhatsappChat(row)}
                                    >
                                        <span style="margin-right: 3px; display: block; font-size: 12px">
                                            Start Chat
                                        </span>
                                    </a-button>
                                )
                            );
                        };

                        const renderStartWhatsappV1 = () => {
                            return (
                                this.isWhatsappV1(row) && (
                                    <a-button
                                        class="actionButton d-flex align-items-center classic-button"
                                        size="small"
                                        on-click={() => this.startWhatsappChat(row)}
                                    >
                                        <span style="margin-right: 3px; display: block; font-size: 12px">
                                            Start Chat
                                        </span>
                                    </a-button>
                                )
                            );
                        };

                        const renderStartWhatsappV2 = () => {
                            return (
                                this.isWhatsappV2(row) && (
                                    <a-button
                                        class="actionButton d-flex align-items-center classic-button"
                                        size="small"
                                        on-click={() => this.startWhatsappChat(row)}
                                    >
                                        <span style="margin-right: 3px; display: block; font-size: 12px">
                                            Start Chat
                                        </span>
                                    </a-button>
                                )
                            );
                        };

                        return (
                            <div style="display: flex; flex-direction: column; justify-content: flex-end">
                                <span style="display: flex; flex-direction: row">
                                    <a-button
                                        class="actionButton d-flex align-items-center classic-button"
                                        size="small"
                                        on-click={() => this.clickLine(row)}
                                    >
                                        <span style="margin-right: 3px; display: block; font-size: 12px">
                                            {this.$t("message.userProfile")}
                                        </span>
                                    </a-button>
                                    {renderStartWABusiness()}
                                    {renderStartWhatsappV1()}
                                    {renderStartWhatsappV2()}
                                    <button
                                        class="actionButton d-flex align-items-center background-transparent"
                                        size="small"
                                        on-click={() => this.view(row._id, row.index)}
                                    >
                                        <EyesIcon />
                                    </button>
                                </span>
                            </div>
                        );
                    },
                },
            ];
            if (this.isCustomLoginFormEnabled) {
                let customCols = this.customLoginInputs
                    .filter((x) => !["email", "fullname", "whatsappNumber"].includes(x.type))
                    .map((x) => {
                        return {
                            title: x.name,
                            field: x.name,
                            key: x._id,
                        };
                    });
                cols = [
                    {
                        title: this.$t("message.fullName"),
                        field: "fullname",
                        key: "fullname",
                    },
                    {
                        title: this.$t("message.email"),
                        field: "email",
                        key: "email",
                    },
                    ...customCols,
                    ...cols,
                ];
            } else {
                cols = [
                    {
                        title: this.$t("message.fullName"),
                        field: "fullname",
                        key: "fullname",
                    },
                    {
                        title: this.$t("message.email"),
                        field: "email",
                        key: "email",
                    },
                    ...cols,
                ];
            }
            this.defaultCols = cols;
            this.tableCols =
                this.tableCols ||
                cols.reduce((acc, cur) => {
                    acc[cur.key] = true;
                    return acc;
                }, {});
            // log.debug("getCols called", { cols });
            return cols.filter((x) => this.tableCols[x.key]);
        },
        channelMap() {
            return this.channel.reduce((map, channel) => {
                map[channel._id] = channel.name;
                return map;
            }, {});
        },
        channelTypeMap() {
            return this.channel.reduce((map, channel) => {
                map[channel._id] = channel.type;
                return map;
            }, {});
        },
    },
    methods: {
        ...mapActions({
            getVisitors: "visitor/getVisitors",
            loadOldMessages: "chat/loadOldMessages",
            getUsers: "user/getUsers",
            getCustomerDomainsIfNeed: "visitor/getCustomerDomainsIfNeed",
            banVisitor: "visitor/banVisitor",
            unbanVisitor: "visitor/unbanVisitor",
            addNewWindow: "app/addNewWindow",
        }),
        toLocalStorage() {
            localStorage.setItem("visitorHistoryTableCols", JSON.stringify(this.tableCols));
        },
        saveDate() {
            this.$emit("customTime");
            this.saveFilters();
        },
        saveFilters() {
            getOrUpdateFilters("chat-visitor-history", {
                startDate: this.startDate,
                endDate: this.endDate,
                query: this.query,
                point: this.point,
                selectedUser: this.selectedUser,
                selectedCustomerDomains: this.selectedCustomerDomains,
            });
        },
        handleResetFilters(resetValues) {
            this.$emit("timeSelectChanged", "today");
            this.startDate = resetValues.startDate;
            this.endDate = resetValues.endDate;
            this.query = resetValues.query;
            this.point = resetValues.point;
            this.selectedUser = resetValues.selectedUser;
            this.selectedCustomerDomains = resetValues.selectedCustomerDomains;
            this.getHistory();
        },
        isWABusiness(chat) {
            const channelId = _.get(chat, "channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "whatsapp-business-api";
        },
        isWhatsappV1(chat) {
            const channelId = _.get(chat, "channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "whatsapp-v1" || _.get(channel, "type") === "whatsapp-qr";
        },
        isWhatsappV2(chat) {
            const channelId = _.get(chat, "channel");
            const channel = this.channels.find((c) => c._id === channelId);
            return _.get(channel, "type") === "whatsapp-v2";
        },
        startWhatsappChat(chat) {
            const channelId = _.get(chat, "channel");
            const whatsappNumber = _.get(chat, "whatsappNumber");
            if (!whatsappNumber) return;
            if (!channelId) return;
            log("startChat", { whatsappNumber, channelId });
            const maybeJoinedChat = this.myActiveConversations.find(
                (x) => x.whatsappNumber === whatsappNumber || x.whatsappNumber === whatsappNumber
            );
            if (!!maybeJoinedChat) {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.OPEN_CHAT, {
                    conversationId: maybeJoinedChat._id,
                });
            } else {
                const hide = this.$message.loading(this.$t("wp.chatStartingWait"), 0);

                socketMessageStream
                    .pipe(
                        filter((x) => x.cmd === "join_chat_immediately"),
                        timeout(5000),
                        first()
                    )
                    .toPromise()
                    .then((x) => {
                        this.$message.success(this.$t("wp.chatStarted"));
                    })
                    .catch((err) => {
                        this.$message.error(this.$t("wp.chatNotStarted"));
                    })
                    .finally(() => {
                        hide();
                    });
                sendSocketMessage("user start-chat", {
                    siteId: this.site._id,
                    userId: this.user._id,
                    whatsappNumber: whatsappNumber,
                    channelId: channelId,
                    channelType: this.channelTypeMap[channelId],
                });
            }
        },
        getPhoneNumber() {
            const findCustomLoginInfo = this.customLoginInputs.find((v) => v.type === "phone");
            const phoneNumber = this.selectedHistory.visitor.customLoginInfos.find(
                (v) => v.input === findCustomLoginInfo?._id
            );
            return phoneNumber?.value || "-";
        },
        navigateHistory(direction) {
            const currentId = this.selectedHistory.visitor._id;
            const currentIndex = this.visitors.data.findIndex((v) => v._id === currentId);
            const newIndex = currentIndex + direction;

            if (newIndex >= 0 && newIndex < this.visitors.data.length) {
                const newId = this.visitors.data[newIndex]._id;
                this.view(newId, newIndex);
            }
        },
        getCustomLoginInfos() {
            let inputValues = _.get(this.selectedHistory, "visitor.customLoginInfos", []);
            log.info("getCustomLoginInfos", { inputValues });
            inputValues = inputValues
                .filter((v) => this.inputs[v.input] && !!v.value)
                .map((v) => ({
                    value: this.inputs[v.input].type === "subject" ? this.getSubjectName(v.value) : v.value,
                    name: this.inputs[v.input].localizedLabel[this.$i18n.locale].text,
                }));
            log.info("getCustomLoginInfos", { inputValues });
            return inputValues;
        },
        getSubjectName(id) {
            let maybeSubject = this.subjects.find((x) => x._id == id);
            return maybeSubject ? maybeSubject.languageContent[i18n.locale].name : undefined;
        },
        getInputValue(data, input) {
            log.info("getInputValue", { data, input });
            let maybeInput = (data.customLoginInfos || []).find((x) => x.input === input._id);
            log.info("getInputValue", { data, input, maybeInput, customLoginInputs: this.customLoginInputs });
            if (maybeInput) {
                let inputSchema = this.customLoginInputs.find((x) => x._id === input._id);
                if (inputSchema.type === "subject") {
                    return this.getSubjectName(maybeInput.value);
                }
                return maybeInput.value;
            }
            if (input.type === "email") return data.email || "-";
            if (input.type === "fullname") return data.fullname || "-";
            return "-";
        },
        getSubject(item) {
            return this.getSubjectName(item?._id);
        },
        tableChange(pagination, filters, sorter) {
            /*log("tableChange", {pagination, filters, sorter});*/
            const newSort = {
                columnKey: sorter.columnKey,
                order: sorter.order,
            };
            const oldSort = this.currentSort;
            log.debug("sort debug", {
                oldSort: { ...oldSort },
                newSort: { ...newSort },
                eq: _.isEqual(newSort, oldSort),
            });
            if (!_.isEqual(newSort, oldSort)) {
                this.currentSort = newSort;
                log.debug("sort changed", {
                    newSort,
                });
                this.renderCount += 1;
                this.$forceUpdate();
            }
        },
        setCustomDateFilter(filter) {
            log.debug("setCustomDateFilter ", filter);
            if (filter === "today") {
                this.startDate = moment().startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "yesterday") {
                this.startDate = moment().subtract(1, "days").startOf("day").toISOString();
                this.endDate = moment().subtract(1, "days").endOf("day").toISOString();
            } else if (filter === "current-week") {
                this.startDate = moment().startOf("week").startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "last-week") {
                this.startDate = moment().startOf("isoWeeks").subtract(1, "days").startOf("isoWeeks").toISOString();
                this.endDate = moment().startOf("isoWeeks").subtract(1, "days").endOf("isoWeeks").toISOString();
            } else if (filter === "current-month") {
                this.startDate = moment().startOf("month").startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "last-month") {
                this.startDate = moment().startOf("month").subtract(1, "days").startOf("month").toISOString();
                this.endDate = moment().startOf("month").subtract(1, "days").endOf("month").toISOString();
            } else if (filter === "last-30") {
                this.startDate = moment().subtract(30, "days").startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "all-time") {
                this.startDate = null;
                this.endDate = null;
            } else if (typeof filter === "object") {
                this.startDate = filter.start;
                this.endDate = filter.end;
            }
        },
        getLast11Months() {
            return TimeUtils.getLast11Months();
        },
        getUserNames(item) {
            return (item.users && item.users.length > 0 ? _.uniqBy(item.users, (q) => q._id) : [item.connectedUser])
                .map((x) => this.getUserName(x))
                .join(" ; ");
        },
        getUserName(userObjectOrUserId) {
            const isUserObject = typeof userObjectOrUserId === "object";
            const isUserId = typeof userObjectOrUserId === "string";
            if (isUserObject) {
                return userObjectOrUserId.name;
            } else if (isUserId) {
                let newUser = "-";
                const maybeUserObj = this.users !== null && this.users.find((x) => x._id === userObjectOrUserId);
                if (maybeUserObj) {
                    newUser = maybeUserObj.name;
                }
                log("getUserHelper", userObjectOrUserId, newUser, maybeUserObj);
                return newUser;
            } else {
                return "-";
            }
        },
        getParticipants() {
            const supportUsers = this.filteredMessages
                .filter((x) => x.messageType === "user" || x.messageType === "private")
                .map((x) => ({
                    id: x.userId,
                    name: x.username,
                }));

            return _.uniqBy(supportUsers, (q) => q.name);
        },
        getMessages() {
            let allMessages = toNewMessagesModel(this.filteredMessages, this);

            if (this.typingMessage) {
                allMessages = [
                    ...allMessages,
                    {
                        type: "typing",
                        data: {
                            text: this.typingMessage,
                        },
                    },
                ];
            }

            return allMessages;
        },
        getHistory(resetPage = false) {
            if (resetPage) {
                this.paginationCursor.page = 1;
            }

            this.loading = true;
            log("getHistory running ", { query: this.query });
            const skipCount =
                this.paginationCursor.page * this.paginationCursor.perPage - this.paginationCursor.perPage;

            getOrUpdateFilters("chat-visitor-history", {
                pageSize: this.paginationCursor.perPage,
                current: this.paginationCursor.page,
                startDate: this.startDate,
                endDate: this.endDate,
                query: this.query,
                point: this.point,
                selectedUser: this.selectedUser,
                selectedCustomerDomains: this.selectedCustomerDomains,
                selectedChannel: this.selectedChannel,
            });

            this.getVisitors({
                limit: this.paginationCursor.perPage,
                skipCount: skipCount > 0 ? skipCount : 0,
                startDate: this.startDate,
                endDate: this.endDate,
                query: this.query,
                point: this.point,
                userId: this.selectedUser,
                homeSite: this.selectedCustomerDomains,
                channelIds: this.selectedChannel.join(","),
            })
                .then()
                .finally(() => (this.loading = false));
        },
        view(id, i) {
            const selectedVisitor = this.visitors.data.find((v) => v._id === id);
            const rowIndex = i;
            this.loadOldMessages(id).then((response) => {
                let items = response.data.data;
                items = _.orderBy(
                    _.uniqBy(items, (q) => q.uniqMessageId || q._id),
                    (q) => moment(q.createdDate).toDate().getTime(),
                    "asc"
                );
                this.selectedHistory = {
                    visitor: selectedVisitor,
                    messages: items,
                    rowIndex: rowIndex,
                };
                this.visible = true;
            });
        },
        downloadConversationData() {
            let rawData = this.selectedHistory.messages.filter(
                (x) => x.messageType === "visitor" || x.messageType === "user"
            );
            let formattedData = rawData.map((x) => {
                let name;
                let date = moment(x.createdDate).format("HH:mm:ss");
                let message = (x.description || "").replace(/(<([^>]+)>)/gi, "");
                if (x.messageType === "visitor") {
                    name = this.selectedHistory.visitor.fullname;
                } else {
                    name = `${x.username}(${this.$t("message.representative_")})`;
                }
                return {
                    name: name,
                    date: date,
                    message: message,
                };
            });
            return formattedData;
        },
        downloadConversationFields() {
            return [
                {
                    label: this.$t("message.username"),
                    field: "name",
                },
                {
                    label: this.$t("message.date"),
                    field: "date",
                },
                {
                    label: this.$t("message.message"),
                    field: "message",
                },
            ];
        },
        reset() {
            this.selectedHistory = {
                visitor: {},
                messages: [],
            };
        },
        fetchAllUsers() {
            this.getUsers({ perPage: 1000, page: 1 }).then((response) => {
                // log("getUsers completed", response.data);
                this.usersFilter = response.data;
            });
        },
        queryChanged: _.debounce(function (newQuery, oldQuery) {
            // log("queryChanged", { newQuery, oldQuery });
            if (newQuery !== oldQuery) {
                this.page = 1;
                this.getHistory(true);
            }
        }, 1000),
        getExcellData() {
            return this.visitors.data.map((x) => {
                const customLoginInfo = {};
                (x.customLoginInfos || []).forEach((info) => {
                    const inputMeta = this.customLoginInputs.find((input) => input._id === info.input);
                    if (inputMeta) {
                        customLoginInfo[inputMeta.name] = info.value;
                    }
                });

                return {
                    ...x,
                    country: x.geoLocation ? x.geoLocation.country : "N/A",
                    user: this.getAgentNames(x) || "-",
                    createdDate: moment(x.createdDate).format("DD MMM, HH:mm:ss"),
                    destroyedDate: x.destroyedDate ? moment(x.destroyedDate).format("DD MMM, HH:mm:ss") : "-",
                    timeSpent: x.destroyedDate
                        ? Math.ceil(moment.duration(moment(x.destroyedDate).diff(x.createdDate)).asMinutes()) + "dk"
                        : "-",
                    subject: this.getSubjectName(x.subject),
                    comment: x.description,
                    ...customLoginInfo,
                };
            });
        },
        getFileName() {
            return "conversation-history.xlsx";
        },
        getAgentNames(chat) {
            return chat.users
                .map((id) => {
                    const u = this.users.find((x) => x._id === id);
                    return u ? u.name : "";
                })
                .join(",");
        },
        clickLine(item, index) {
            this.addNewWindow({
                type: "show-visitor",
                title: this.$t("task.whatsappContactProfileTitle", {
                    name: item.visitor.fullname,
                    number: item.visitor.phoneNumber,
                }),
                payload: {
                    visitorId: item.visitor._id,
                },
            });
        },
        ban() {
            const visitorId = this.visitors.data[this.rowIndex].visitor._id;
            this.banVisitor(visitorId);
            this.selectedHistory.visitor.isBlocked = true;
            this.$message.success(this.$t("coupon.visitorBan"));
        },
        unban() {
            const visitorId = this.visitors.data[this.rowIndex].visitor._id;
            this.unbanVisitor(visitorId);
            this.selectedHistory.visitor.isBlocked = false;
            this.$message.success(this.$t("coupon.visitorUnBlock"));
        },
        exportToExcel() {
            const dataToExport = this.getExcellData();
            expertToExcel(dataToExport, this.getFileName(), "Sheet 1");
        },
        downloadAsFile() {
            const skipCount = this.current * this.pageSize - this.pageSize;
            this.getVisitors({
                limit: this.pageSize,
                skipCount: skipCount > 0 ? skipCount : 0,
                startDate: this.startDate,
                endDate: this.endDate,
                query: this.query,
                point: this.point,
                userId: this.selectedUser,
                homeSite: this.selectedCustomerDomains,
                downloadAsFile: true,
            })
                .then((data) => {
                    const { s3Key } = data;
                    const url = `https://static.supsis.live/${s3Key}`;
                    window.open(url, "_blank");
                })
                .catch((err) => {
                    console.error(err);
                    this.$message.error(this.$t("message.error"));
                });
        },
        openVisitorHistorySettingsModal() {
            this.visitorHistorySettingsModalVisible = true;
        },
        closeVisitorHistorySettingsModal() {
            this.visitorHistorySettingsModalVisible = false;
        },
        filterByChannel() {
            this.getHistory(true);
        },
    },
    mounted() {
        this.setCustomDateFilter(this.timeSelect);
        moment.locale(this.$i18n.locale);
        this.fetchAllUsers();
        this.getHistory();
        window.addEventListener("keydown", (e) => {
            if (e.key === "ArrowDown" && (e.ctrlKey || e.metaKey)) {
                if (this.rowIndex < 10) {
                    this.view(this.visitors.data[this.rowIndex + 1]._id, this.rowIndex + 1);
                }
                e.preventDefault();
            } else if (e.key === "ArrowUp" && (e.ctrlKey || e.metaKey)) {
                if (this.rowIndex > 0) {
                    this.view(this.visitors.data[this.rowIndex - 1]._id, this.rowIndex - 1);
                }
                e.preventDefault();
            }
        });
        this.getCustomerDomainsIfNeed();
    },
    updated() {
        if (moment.locale() !== this.$i18n.locale) moment.locale(this.$i18n.locale);
        // log("visitor history data ", this.visitors.data);
    },
    watch: {
        visitors(newValue, oldValue) {
            this.paginationCursor.total = newValue.total;
        },
        startDate(newValue, oldValue) {
            if (newValue) {
                this.page = 1;
                this.getHistory(true);
            }
        },
        endDate(newValue, oldValue) {
            if (newValue) {
                this.page = 1;
                this.getHistory(true);
            }
        },
        paginationCursor: {
            deep: true,
            handler() {
                this.getHistory(false);
            },
        },
        selectedUser(newValue, oldValue) {
            this.page = 1;
            this.getHistory(true);
        },
        query(newValue, oldValue) {
            this.queryChanged(newValue, oldValue);
            this.query = newValue;
        },
        point(newValue, oldValue) {
            this.point = newValue;
            this.getHistory(true);
        },

        timeSelect(newVal, oldVal) {
            this.setCustomDateFilter(newVal);
        },
        selectedCustomerDomains(newVal) {
            this.getHistory();
        },
        selectedSubject() {
            this.getHistory(true);
        },
        selectedChannel(newVal) {
            this.filterByChannel();
        },
    },
};
</script>

<style lang="scss">
#channel-filter {
    .ant-select-selection {
        background-color: #ffffff !important;
        border: transparent !important;
        height: 5px !important;
        overflow: auto !important;
    }
}

#visitor-history {
    padding: 30px;
}
.new-theme {
    .custom-input input,
    .custom-input ul,
    .custom-input select {
        background-color: var(--white);
        border: 1px solid var(--color-border-default);
        border-radius: 6px !important;
        height: 30px;
    }

    .actionButton {
        border: none;
        box-shadow: none;
    }

    .custom-input ul {
        padding: 4px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
    }

    #visitor-history {
        .excel-style {
            border: none;
            position: absolute;
            left: 10px;
            top: 30px;
            background: var(--white);
            box-shadow: 0 0 4px #00000052;
            border-radius: 5px;
            padding: 4px 11px;
            display: none;
        }

        &:hover .excel-style {
            display: block;
        }
    }

    #visitor-history-row {
        .col {
            :not(:last-child) {
                padding-right: 5px !important;
            }
        }
    }
}

.background-transparent {
    background-color: transparent !important;
}

#visitor-history-modal .messages {
    max-height: 500px !important;

    .sc-message-list {
        width: 100% !important;
    }
}

#visitor-history-modal .custom-modal-body {
    width: 1000px !important;
}

#visitor-history-modal .ant-modal-content {
    width: 1000px !important;
    position: relative;
    right: 50%;
}

#visitor-history-modal .icon {
    margin-right: 8px;
    color: #ffa800;
}
</style>
<style lang="scss">
.userInfo {
    font-family: Poppins;

    &.first {
        color: #3699ff;
        font-size: 16px;
        font-weight: 500;
        padding-top: 15px;
        line-height: 1;
    }

    &.sec {
        color: #181c32;
        font-size: 14px;
        font-weight: 300;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        max-width: 300px;
        -webkit-box-orient: vertical;
    }
}
</style>

<style lang="scss" scoped>
.tableSettingsBtn {
    position: absolute !important;
    left: 8px !important;
    top: 55px !important;
}
.item {
    margin-bottom: 10px;
}

.checkbox-group b-form-checkbox {
    display: block;
    margin-bottom: 5px;
}

.clear {
    clear: both;
}

.ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    max-width: 300px;
    -webkit-box-orient: vertical;
}

.classic-button {
    border: none;
    background-color: #ffa80040;
    color: #ffa800;
    font-family: Poppins;
    font-weight: 600 !important;
    font-size: 14px;
    cursor: pointer;
    padding: 3px 10px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5px;
}

.parent-div {
    display: flex;
    justify-content: space-between;
    gap: 40px;
}

.download-button {
    background: transparent;
    border-color: transparent;

    .md-icon.md-theme-default.md-icon-font {
        color: #ffa800;
    }
}

.back-and-forth-button {
    display: flex;
    justify-content: end;
    margin-top: 20px;

    .ant-btn {
        font-size: 20px;
        color: #ffa800;
        margin: 2px;
    }

    .ant-btn:hover {
        border-color: #ffa800;
    }

    .ant-btn:focus {
        border-color: #ffa800;
    }

    span {
        color: #ffa800;
        margin: 0px 10px;
        font-size: 30px;
    }
}

.filteredMessages {
    display: flex;
    flex-direction: column;
}

.display-flex {
    display: flex;
}
</style>
